export { default } from './Grow';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Grow/index.js
// module id = 71
// module chunks = 0